export type SeoTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export interface SeoSlot {
  text: string;
  tag: SeoTag;
  enabled: boolean;
  sortOrder: number;
}

export interface ApiPageHeadingSlot {
  slotKey: string;
  text?: string | null;
  effectiveText?: string | null;
  defaultText?: string | null;
  tagName?: number | string | null;
  isActive?: boolean | null;
  sortOrder?: number | null;
  notes?: string | null;
}

export type HomeSeoSlots = Record<string, SeoSlot>;

export const HOME_SEO_DEFAULTS: HomeSeoSlots = {
  otherServicesTitle: { text: 'سایر خدمات ایرانیجا', tag: 'h2', enabled: true, sortOrder: 1 },
  otherServiceSupportTitle: { text: 'پشتیبانی و پیگیری رزرو', tag: 'h3', enabled: true, sortOrder: 2 },
  otherServiceRefundTitle: { text: 'استرداد رزرو', tag: 'h3', enabled: true, sortOrder: 3 },

  specialOffersTitle: { text: 'پیشنهادات ویژه ایرانیجا', tag: 'h2', enabled: true, sortOrder: 10 },
  specialOffersMainTitle: { text: 'ایرانـیــــجا', tag: 'h3', enabled: true, sortOrder: 11 },
  specialOffersBanner1Title: { text: 'سفر رویایی تو شروع کن!', tag: 'h4', enabled: true, sortOrder: 12 },
  specialOffersBanner2Title: { text: 'سفر زیارتی با بهترین قیمت', tag: 'h4', enabled: true, sortOrder: 13 },
  specialOffersBanner3Title: { text: 'جنگل‌های بارانی شمال', tag: 'h4', enabled: true, sortOrder: 14 },

  whyIranijaTitle: { text: 'چرا ایرانیجا؟', tag: 'h2', enabled: true, sortOrder: 20 },
  whyFeature1Title: { text: 'رزرو آسان', tag: 'h3', enabled: true, sortOrder: 21 },
  whyFeature2Title: { text: 'گارانتی بهترین قیمت', tag: 'h3', enabled: true, sortOrder: 22 },
  whyFeature3Title: { text: 'پشتیبانی تخصصی', tag: 'h3', enabled: true, sortOrder: 23 },
  whyFeature4Title: { text: 'پوشش سراسری', tag: 'h3', enabled: true, sortOrder: 24 },

  hotelsTitle: { text: 'هتل‌های ایرانیجا', tag: 'h2', enabled: true, sortOrder: 30 },
  hotelTitle1: { text: 'هتل‌های تهران', tag: 'h3', enabled: true, sortOrder: 31 },
  hotelTitle2: { text: 'هتل‌های اصفهان', tag: 'h3', enabled: true, sortOrder: 32 },
  hotelTitle3: { text: 'هتل‌های اهواز', tag: 'h3', enabled: true, sortOrder: 33 },

  faqTitle: { text: 'سئوالات متداول', tag: 'h2', enabled: true, sortOrder: 40 },
  faqQuestion1: { text: 'چطور می‌توانم از ایرانیجا هتل رزرو کنم؟', tag: 'h3', enabled: true, sortOrder: 41 },
  faqQuestion2: { text: 'برای رزرو هتل باید حتما ثبت نام انجام دهم؟', tag: 'h3', enabled: true, sortOrder: 42 },
  faqQuestion3: { text: 'کدهای تخفیف ایرانیجا چطور کار می‌کنند؟', tag: 'h3', enabled: true, sortOrder: 43 },
  faqQuestion4: { text: 'بعد از رزرو هتل می‌توانم کنسل یا استرداد انجام دهم؟', tag: 'h3', enabled: true, sortOrder: 44 },
  faqQuestion5: { text: 'ایرانیجا برای کدام شهرها هتل دارد؟', tag: 'h3', enabled: true, sortOrder: 45 },
};

const TAG_BY_NUMBER: Record<number, SeoTag> = {
  1: 'h1',
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
};

function normalizeText(value?: string | null): string {
  return (value ?? '').trim();
}

export function toSeoTag(value?: number | string | null, fallback: SeoTag = 'h2'): SeoTag {
  if (typeof value === 'number') {
    return TAG_BY_NUMBER[value] ?? fallback;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'h1' || normalized === 'h2' || normalized === 'h3' || normalized === 'h4' || normalized === 'h5' || normalized === 'h6') {
      return normalized;
    }
  }

  return fallback;
}

export function mergeHomeSeoSlots(apiSlots: ApiPageHeadingSlot[] = []): HomeSeoSlots {
  const merged: HomeSeoSlots = { ...HOME_SEO_DEFAULTS };

  for (const slot of apiSlots) {
    const key = slot.slotKey?.trim();
    if (!key) continue;

    const current = merged[key] ?? {
      text: '',
      tag: 'h2' as SeoTag,
      enabled: false,
      sortOrder: slot.sortOrder ?? 0,
    };

    merged[key] = {
      text: normalizeText(slot.effectiveText ?? slot.text ?? slot.defaultText) || current.text,
      tag: toSeoTag(slot.tagName, current.tag),
      enabled: typeof slot.isActive === 'boolean' ? slot.isActive : current.enabled,
      sortOrder: typeof slot.sortOrder === 'number' ? slot.sortOrder : current.sortOrder,
    };
  }

  return merged;
}

// export function getHomeSlot(slots: HomeSeoSlots, key: string): SeoSlot {
//   return slots[key] ?? { text: '', tag: 'h2', enabled: false, sortOrder: 0 };
// }

export function getHomeSlot(slots: HomeSeoSlots | undefined | null, key: string): SeoSlot {
  return slots?.[key] ?? {
    text: '',
    tag: 'h2',
    enabled: false,
    sortOrder: 0,
  };
}